import { Typography } from "antd";
import DashboardLayout from "layout/DashboardLayout";
import OnboardingLayout from "layout/OnboardingLayout";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ONBOARDING_ROUTES } from "utils/routes";

export default function ApplicationRedirect() {
  const navigate = useNavigate();
  const [second, setSecond] = useState(5);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      navigate(ONBOARDING_ROUTES.Status);
    }, second * 1000);
    const intervalId = setInterval(() => {
      setSecond((prev) => prev - 1);
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardLayout>
      <OnboardingLayout>
        <Typography.Text className="!p-5 block text-center">
          Application not found. Redirecting to status page in <strong className="tabular-nums">{second}</strong>{" "}
          seconds
        </Typography.Text>
      </OnboardingLayout>
    </DashboardLayout>
  );
}
